export default __webpack_public_path__ + "static/media/logo.1a2196a7.png";